const storage: Record<string, string> = {};

export default {
  get(key: string): string | undefined {
    return storage[key];
  },
  set(key: string, value: string): void {
    storage[key] = value;
  },
  remove(key: string): void {
    delete storage[key];
  },
};
